import { Tag } from 'antd';

// Презентационный тег канала сообщения. Единый источник для журнала тенанта
// (`MessagesPage`) и кросс-tenant журнала платформы (`PlatformJournalPage`).
// channel приходит строкой из API (`telegram` | `sms` | ...); неизвестное
// значение показываем как есть.
const CHANNEL_LABELS: Record<string, string> = {
  telegram: 'Telegram',
  sms: 'SMS',
  whatsapp: 'WhatsApp',
  push: 'Push',
};

export function ChannelTag({ channel }: { channel: string }): JSX.Element {
  return <Tag>{CHANNEL_LABELS[channel] ?? channel}</Tag>;
}
